import{jsx as $}from"react/jsx-runtime";import i,{css as t}from"styled-components";import{mq as l}from"../../shared/media-queries.js";const n=t`
  font-family: ${({theme:e})=>e.typography.fontAlternativeFamily};
  font-weight: ${({theme:e})=>e.typography.fontAlternativeBoldWeight};
`,r=t`
  ${n}
  font-size: 2.5rem;
  line-height: 3rem;

  ${l("laptop")} {
    font-size: 4rem;
    line-height: 4.5rem;
  }
`,z=i.p`
  ${r}
`,h=t`
  ${n}
  font-size: 2rem;
  line-height: 2.5rem;

  ${l("laptop")} {
    font-size: 3rem;
    line-height: 4rem;
  }
`,S=i.p`
  ${h}
`,m=t`
  ${n}
  font-size: 1.75rem;
  line-height: 2.5rem;

  ${l("laptop")} {
    font-size: 2.5rem;
    line-height: 3.5rem;
  }
`,T=i.p`
  ${m}
`,o=t`
  font-family: ${({theme:e})=>e.typography.fontAlternativeFamily};
  font-weight: ${({theme:e})=>e.typography.fontAlternativeRegularWeight};
`,p=t`
  ${o}
  font-size: 1.75rem;
  line-height: 2rem;

  ${l("laptop")} {
    font-size: 2rem;
    line-height: 3rem;
  }
`,c=i.p`
  ${p}
`,a=t`
  ${o}
  font-size: 1.5rem;
  line-height: 2rem;

  ${l("laptop")} {
    font-size: 1.75rem;
    line-height: 2.5rem;
  }
`,d=i.p`
  ${a}
`,y=t`
  ${o}
  font-size: 1.125rem;
  line-height: 2rem;

  ${l("laptop")} {
    font-size: 1.25rem;
  }
`,v=i.p`
  ${y}
`,f=t`
  font-family: ${({theme:e})=>e.typography.fontAlternativeFamily};
  font-size: 1rem;
  line-height: 1.5rem;
`,g=t`
  ${f}
  font-weight: ${({theme:e})=>e.typography.fontAlternativeRegularWeight};
`,u=i.p`
  ${g}
`,s=t`
  ${f}
  font-weight: ${({theme:e})=>e.typography.fontAlternativeBoldWeight};
`,A=i.p`
  ${s}
`,D=()=>$("div",{});export{T as Display1,m as Display1Style,S as Display2,h as Display2Style,z as Display3,r as Display3Style,c as Headline,p as HeadlineStyle,v as Subtitle,y as SubtitleStyle,A as TinyTitleBold,s as TinyTitleBoldStyle,u as TinyTitleRegular,g as TinyTitleRegularStyle,d as Title,a as TitleStyle,D as default};
